import { useState } from "react";
import { cn } from "@/lib/utils";
import { Gift } from "lucide-react";

interface BlurImageProps {
  src: string;
  alt: string;
  className?: string;
}

const BlurImage = ({ src, alt, className }: BlurImageProps) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  if (error) {
    return (
      <div className={cn("w-full h-full flex items-center justify-center bg-muted/50", className)}>
        <Gift size={22} className="text-muted-foreground/30" />
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      referrerPolicy="no-referrer"
      crossOrigin="anonymous"
      onLoad={() => setLoaded(true)}
      onError={() => setError(true)}
      className={cn(
        "transition-all duration-700 ease-out",
        loaded ? "blur-0 scale-100" : "blur-md scale-105",
        className
      )}
    />
  );
};

export default BlurImage;
